export default __webpack_public_path__ + "static/media/raiffeisen_l2.a0f150f1.png";